module.exports = __webpack_public_path__ + "static/media/more-selected.2668d278.svg";